module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-main-light-v2"
  }, [_c('div', {
    staticClass: "container g-py-20"
  }, [_c('carousel', {
    staticClass: "js-carousel",
    attrs: {
      "perPageCustom": [
        [280, 1],
        [768, 1]
      ],
      "autoplay": true,
      "loop": true,
      "autoplayTimeout": 10000,
      "data-pagi-classes": "u-carousel-indicators-v35--white g-pos-rel text-center"
    }
  }, [_c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("Simply put, Changing Life through Lenses® has significantly expanded our ability to serve the underserved with the gift of sight.  I can not overstate how critical this is to those suffering in our community.\r\n                        "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4  g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Rupert C. Chowins, O.D.")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Eye Clinic Director, SLO Noor Free Clinic")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("A friend (also an OD) and I have been using your program to provide glasses to the homeless in Philadelphia. We have felt drawn to help this population on a pro bono basis for a long time and now we can provide them with no cost quality vision correction!  Many times, those who are materially poor do not have many choices, so it is wonderful to have such a terrific selection of stylish and quality frames to offer them. They were so pleased and excited!\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Christine Chmielewski, O.D.")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("For almost 15 years, we have been setting aside four exam slots per month for Howard Brown Health Center patients. The cost of providing high quality eye wear kept us from being able to offer even more services. Changing Life through Lenses® makes ordering easy, the glasses are high quality and are provided in a timely manner.  Now that the cost of the eye wear is not an obstacle, we are able to open up our services to more patients.\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Michael Ciszek, O.D.")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Visionary Eye Care Professionals")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("This effort has the potential to make a real impact on a large number of kids in underserved communities across the U.S. – all of us here at HKI are super excited!\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Meghan K. Lynch")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Director, ChildSight® U.S. Helen Keller International\r\n                  ")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("Our patients are always so pleased when they hear that we are doing charitable giving and we always give CLTL the credit! It's definitely a great practice builder -- do what's right for the patient and it'll always help your practice. It also makes the staff happy to see we are helping patients at no charge to them. It makes them feel like they are part of something special and shows that the goal of the practice is to help people. Of course, they know that we need to make money to keep the doors open, but it's not about that, it's about the patients.\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Dr. Suzanne Zamberlan of Evergreen")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Eye Care in Vancouver, WA\r\n                    ")])])])])])], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2140195a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2140195a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomeBlock.vue
// module id = 467
// module chunks = 3